import React, { useEffect, useState } from "react";
import axiosInstance from "../../axios";
import { Loading } from "../Other/Loading";


const StudentExamResult = () => {
  const [getExamResult, setGetExamResult] = useState();
  const [fetchStatus, setFetchStatus] = useState(true);
  const [dataIndex, setDataIndex] = useState(5);
  useEffect(() => {
    axiosInstance
      .get("/test/list")
      .then((res) => {
        setGetExamResult(res.data.data.data);
        setFetchStatus(false);
      })
      .catch((error) => {
        console.log(error);
        setFetchStatus(false);
      });
  }, []);
  return (
    <>
      <div className="dashboard-main studentExam-Resultdata">
        <div className="flex-70">
          <div className="margin-top-new-01">
            <div className="box-shadow-new-01">
              <p className="paragraph-css">Exam Result</p>
              <div>
                {fetchStatus && (
                  <div className="admindata-loading">
                    <Loading />
                  </div>
                )}
                <table className="table-width-100 examResultCollectionData">
                  <thead>
                    <tr>
                      <td>Course Name</td>
                      <td>Quiz Name</td>
                      <td>Type</td>
                      <td>Attempts</td>
                      <td>Result</td>
                      <td>Question List</td>
                    </tr>
                  </thead>
                  <tbody>
                    {getExamResult &&
                      getExamResult.length > 0 &&
                      getExamResult.slice(0, dataIndex).map((ele) => (
                        <tr key={ele.id}>
                          <td className="cell">{ele.CourseName}</td>
                          <td className="cell">{ele.name}</td>
                          <td className="cell examResult-tdData">-</td>
                          <td className="cell examResult-tdData">0</td>
                          <td className="cell examResult-tdData">0</td>
                          <td className="cell">
                            <img
                              className="img-link-new"
                              src="https://www.pngfind.com/pngs/m/683-6838012_transparent-link-clipart-external-link-icon-white-hd.png"
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {getExamResult && getExamResult.length > 5 && (
                  <div
                    className="studentViewAllRecords"
                    onClick={() =>
                      setDataIndex(
                        getExamResult && dataIndex === 5
                          ? getExamResult.length
                          : 5
                      )
                    }
                  >
                    {dataIndex === 5 ? "View All" : "View Less"}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StudentExamResult;
